import { Routes } from '@angular/router';
import LayoutComponent from './core/components/layout/layout.component';
import { LoginComponent } from './core/components/login/login.component';
import { AuthenticatedGuard } from './core/auth/guards/authenticated/authenticated.guard';
import { APP_ROUTES } from './core/constants/routes.const';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { OfertaDetalleComponent } from './features/ofertas/components/oferta-detalle/oferta-detalle.component';
import { OfertasConsultaComponent } from './features/ofertas/components/ofertas-consulta/ofertas-consulta.component';
import { OfertasCrearComponent } from './features/ofertas/components/ofertas-crear/ofertas-crear.component';
import { OfertasCompararComponent } from './features/ofertas/components/ofertas-comparar/ofertas-comparar.component';
import { AuthGuard } from './core/auth/guards/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: APP_ROUTES.DASHBOARD,
        component: DashboardComponent,
      },
      {
        path: APP_ROUTES.OFERTAS.BASE,
        component: OfertasConsultaComponent,
      },
      {
        path: APP_ROUTES.OFERTAS.NUEVA,
        component: OfertasCrearComponent,
      },
      {
        path: APP_ROUTES.OFERTAS.DETALLE(':id'),
        component: OfertaDetalleComponent,
      },
      {
        path: APP_ROUTES.OFERTAS.COMPARAR(':id'),
        component: OfertasCompararComponent,
      },
    ],
  },
  {
    path: APP_ROUTES.LOGIN,
    component: LoginComponent,
    canActivate: [AuthenticatedGuard],
  },
  { path: '**', redirectTo: APP_ROUTES.DASHBOARD },
];
